import { AlertTriangle, Loader2, X } from 'lucide-react';

/**
 * Potvrzení nevratné operace (mazání receptu / přídavku).
 *
 * Dřív se mazalo přes nativní `confirm()` — v jiném písmu než zbytek aplikace,
 * bez názvu položky a s tlačítkem „OK", které o následku nic neříká. Tady je
 * vidět, co se maže, a potvrzovací tlačítko je pojmenované akcí.
 */
export default function PotvrzeniModal({
    otevreno, nadpis, popis, polozka, potvrditLabel = 'Smazat', probiha = false,
    isDark, mutedColor, glassCard, btnSecondary, onPotvrdit, onZrusit,
}) {
    if (!otevreno) return null;

    return (
        <div onClick={() => !probiha && onZrusit?.()}
            style={{ position: 'fixed', inset: 0, zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}>
            <div onClick={e => e.stopPropagation()} role="alertdialog" aria-modal="true"
                style={{ ...glassCard, width: 400, maxWidth: '95vw', borderRadius: 12, overflow: 'hidden' }}>
                <div className="flex items-center justify-between p-4" style={{ borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'var(--border-default)'}` }}>
                    <h3 className="text-sm font-semibold flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
                        <AlertTriangle size={15} style={{ color: '#EF4444' }} /> {nadpis}
                    </h3>
                    <button onClick={onZrusit} disabled={probiha} style={{ background: 'none', border: 'none', cursor: 'pointer', color: mutedColor }}><X size={18} /></button>
                </div>

                <div className="p-4 space-y-3">
                    {polozka && (
                        <div className="rounded-lg px-3 py-2 text-xs font-semibold"
                            style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.20)', color: 'var(--text-primary)' }}>
                            {polozka}
                        </div>
                    )}
                    {popis && <p className="text-xs leading-relaxed" style={{ color: mutedColor }}>{popis}</p>}

                    <div className="flex justify-end gap-2 pt-1">
                        <button onClick={onZrusit} disabled={probiha} style={btnSecondary}>Zrušit</button>
                        <button onClick={onPotvrdit} disabled={probiha} autoFocus
                            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold text-white"
                            style={{ background: '#EF4444', border: 'none', cursor: probiha ? 'default' : 'pointer', opacity: probiha ? 0.6 : 1 }}>
                            {probiha && <Loader2 size={13} className="animate-spin" />} {potvrditLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
